import React, { useLayoutEffect } from 'react';
import {
  PageContainer,
  ContentContainer,
  Content,
  Title,
  Text,
  StyledList,
  StyledLi,
  TwoColumnContainer,
  ImageColumn,
  TextColumn,
  TwoColumnImage,
  DateSubtitle,
} from './Hikes.styles';
import { PhotoGallery } from './PhotoGallery';
import { imagesPortugalia2026 } from './images';

export const Portugalia2026: React.FC = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageContainer>
      <ContentContainer>
        <Content>
          <Title>Lizbona i Serra da Estrela</Title>
          <DateSubtitle>01-06.03.2026 | 5 miejsc</DateSubtitle>
          <Text>
            City break w Lizbonie połączony z górami Serra da Estrela. Widokowe trekkingi, lokalne
            atrakcje i przemyślana logistyka.
          </Text>
          <TwoColumnContainer>
            <ImageColumn>
              <TwoColumnImage src="/images/portugalia.jpg" alt="Portugalia 2026" />
              <TwoColumnImage src="/images/malaga.jpg" alt="Malaga" />
            </ImageColumn>
            <TextColumn>
              <Text style={{ marginBottom: '5px' }}>
                <strong>Harmonogram:</strong>
              </Text>
              <StyledList>
                <StyledLi>1.03 - przylot do Lizbony</StyledLi>
                <StyledLi>2.03 - Lizbona - zwiedzanie</StyledLi>
                <StyledLi>3.03 - przejazd do Castelo Novo + atrakcje po drodze</StyledLi>
                <StyledLi>
                  4.03 - trekking Serra da Estrela - 17 km, ~875 m przewyższenia (~7 h)
                </StyledLi>
                <StyledLi>
                  5.03 - trekking Serra da Estrela - 17,5 km, ~380 m przewyższenia (~6 h), Torre
                  1993 m n.p.m.
                </StyledLi>
                <StyledLi>6.03 - przejazd do Lizbony + atrakcje i wylot</StyledLi>
              </StyledList>

              <Text style={{ marginBottom: '5px' }}>
                <strong>W cenie:</strong>
              </Text>
              <StyledList>
                <StyledLi>noclegi (Lizbona + góry)</StyledLi>
                <StyledLi>wynajem auta, ubezpieczenie, paliwo, autostrady, parkingi</StyledLi>
                <StyledLi>Convento de Cristo (Tomar)</StyledLi>
                <StyledLi>Mosteiro dos Jerónimos (Belém)</StyledLi>
                <StyledLi>Castelo de São Jorge (Lizbona)</StyledLi>
                <StyledLi>zwiedzanie Évory (UNESCO)</StyledLi>
                <StyledLi>organizacja trekkingów i wyjść w góry</StyledLi>
                <StyledLi>ubezpieczenie turystyczne</StyledLi>
                <StyledLi>pełna logistyka i opieka</StyledLi>
              </StyledList>
              <Text style={{ marginBottom: '5px' }}>
                <strong>Dodatkowo płatne:</strong>
              </Text>
              <StyledList>
                <StyledLi>wyżywienie</StyledLi>
                <StyledLi>loty</StyledLi>
                <StyledLi>atrakcje dodatkowe</StyledLi>
              </StyledList>
            </TextColumn>
          </TwoColumnContainer>
          <PhotoGallery images={imagesPortugalia2026} />
        </Content>
      </ContentContainer>
    </PageContainer>
  );
};

export default Portugalia2026;
